export const AutomotiveSchema = {
  Labels: {
    dealershipLabel: 'Dealership',
    salesExecLabel: 'Sales Executive',
    customerLabel: 'Customer',
    stockNumberLabel: 'Stock Number'
  }
};